const React = require('react');
const onChangeHandler = require("../utils/onChangeHandler");

module.exports = ({
  className,
  error,
  helperText,
  multiline,
  component,
  type,
  endAdornment,
  withCount,
  inputRef,
  onChange,
  maxLength,
  disableCommas,
  ...props
}) => {
  const Input = component || (multiline ? 'textarea' : 'input');
  const value = props.value || '';
  const valueLength = value.length;

  return (
    <div className={'rlv p3 '
      + (props.disabled ? 'disabled ' : '')
      + (error ? 'error ' : '')
      + (props.value ? 'filled ' : '')
      + (className || '')}
    >
      <Input
        {...props}
        ref={inputRef}
        type={multiline ? null : (type || 'text')}
        onChange={onChangeHandler({onChange, disableCommas, maxLength})}
        className="dB w rsz hmin39 ph22 (pt10|pt11@firefox|pb11)<1.filled
          (pt9|pb12)@firefox pt12 pb9 bxzBB bgF b bc0 ff$3 olN rlv z1
          lts0em f12 fw7 tl (pt8|pt6@firefox|pb9|f18|ff_Verdana,sans-serif)[type=password]<1.filled
        "
      />
      {withCount && (
        <div
          className={`dF fhaE mr10 o50 f12 (o100|cF00).overflow`
          + (valueLength > maxLength ? ' overflow' : '')}
        >
          {valueLength}
          {maxLength && `/${maxLength}`}
        </div>
      )}
      <div className="abs s bs b1 bc0 r6 dn bcF00<1.error o50<1.disabled
        bc0<*:(h|f)+<1:not[.disabled]"/>
      {
        error ? (
          <div
            className={
              `abs sb0 sl0 xY100% f11 cA3A7AC cF00.error fw4 wmin130`
              + (error ? ' error' : '')
            }
          >{helperText || 'Invalid value'}</div>
        ) : null
      }
      {endAdornment || null}
    </div>
  );
};
